import {
    getHostLiveDataByHostId,
    hostLiveSliceActions,
} from '@/modules/hostLive/slice';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { batch } from 'react-redux';
import { getHostByGameId } from '../../../modules/host/slice';
import store from '../../../store/store';
import { GameState } from '../../games/enums/GameState';
import { GameType as GameTypeEnum } from '../../games/enums/GameType';
import { CMDScRoundReset, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDScRoundResetHandler extends AbstractHandler {
    _command: CMDScRoundReset;

    constructor(command: ICommand) {
        super();
        this._command = command as CMDScRoundReset;
    }

    override handle(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        const host = getHostByGameId(state, this._command.GameID);
        const hostLiveData = getHostLiveDataByHostId(state, host.HostId);
        if (host && hostLiveData) {
            batch(() => {
                switch (host.GameType) {
                    case GameTypeEnum.Baccarat:
                    case GameTypeEnum.Dragon:
                        dispatch(
                            hostLiveSliceActions.updatePokerShow({
                                hostId: host.HostId,
                                results: [],
                            })
                        );
                        break;
                }

                dispatch(
                    hostLiveSliceActions.updateGameState({
                        hostId: host.HostId,
                        state: GameState.Started,
                    })
                );
            });
        }
    }
}
